import { Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';
import { ComponentProps, MouseEvent, useMemo } from 'react';

import { createAppModal } from 'utils/modal';

import { FeedbackModalForm } from './components/form/feedbackForm';
import styles from './feedbackModal.module.scss';

/**
 * Represents the modal for customers to provide feedback to Dixa from within
 * the app.
 */
export const FeedbackModal = createAppModal(
  { type: 'app:feedbackForm' },
  ({ isOpen, modal, hide, meta }): JSX.Element => {
    const handleClose = (): void => {
      if (meta) {
        hide();

        meta.resolve({
          isSent: false,
          isCancelled: true,
          feedbackMessage: undefined,
        });
      }
    };

    const modalWrapProps = useMemo<
      ComponentProps<typeof Modal>['wrapProps']
    >(() => {
      return {
        onClick: (e: MouseEvent<HTMLDivElement>) => {
          // Feedback modal can be triggered from dropdowns etc.
          // We don't want to close those dropdown when interacting with this modal
          e.stopPropagation();
        },
      };
    }, []);

    return (
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        className={styles.feedbackModal}
        wrapProps={modalWrapProps}
      >
        <ModalHead title={modal.arg.title} onClose={handleClose} />

        <ModalBody>
          <FeedbackModalForm />
        </ModalBody>
      </Modal>
    );
  },
);
